import apiClient from './client'

export interface AuditLogItem {
  id: number
  user_id: number | null
  actor_id: number | null
  action: string
  ip?: string | null
  created_at: string
  details?: Record<string, unknown> | null
}

export type LogsSortField = 'id' | 'created_at' | 'action' | 'user_id' | 'actor_id'

export interface LogsListParams {
  empresa_id?: number | null
  user_id?: number | null
  actor_id?: number | null
  action?: string | null
  q?: string | null
  since?: string | null
  until?: string | null
  skip?: number
  limit?: number
  sort_by?: LogsSortField
  sort_direction?: 'asc' | 'desc'
}

export interface AuditLogItemFull {
  id: number
  user_id: number | null
  actor_id: number | null
  action: string
  ip?: string | null
  user_agent?: string | null
  host_name?: string | null
  database_name?: string | null
  created_at: string | null
  details?: Record<string, unknown> | null
  user_login_thor?: string | null
  user_name?: string | null
  user_email?: string | null
  actor_login_thor?: string | null
  actor_name?: string | null
  actor_email?: string | null
}

export type AuditLogSortField = 'id' | 'created_at' | 'action' | 'database_name' | 'user_id' | 'actor_id'

export interface AuditLogListParams {
  created_at_from?: string | null
  created_at_to?: string | null
  database_name?: string | null
  details_search?: string | null
  user_id?: number | null
  actor_id?: number | null
  action?: string | null
  skip?: number
  limit?: number
  sort_by?: AuditLogSortField
  sort_direction?: 'asc' | 'desc'
}

export const logsApi = {
  list: async (params?: LogsListParams): Promise<AuditLogItem[]> => {
    const query: Record<string, unknown> = {}
    if (params?.empresa_id) query.empresa_id = params.empresa_id
    if (params?.user_id) query.user_id = params.user_id
    if (params?.actor_id) query.actor_id = params.actor_id
    if (params?.action) query.action = params.action
    if (params?.q) query.q = params.q
    if (params?.since) query.since = params.since
    if (params?.until) query.until = params.until
    query.skip = params?.skip ?? 0
    query.limit = params?.limit ?? 100
    if (params?.sort_by) query.sort_by = params.sort_by
    if (params?.sort_direction) query.sort_direction = params.sort_direction
    const res = await apiClient.get<AuditLogItem[]>('/logs', { params: query })
    return res.data
  },
}

export const auditLogApi = {
  list: async (params?: AuditLogListParams): Promise<AuditLogItemFull[]> => {
    const query: Record<string, unknown> = {}
    if (params?.created_at_from) query.created_at_from = params.created_at_from
    if (params?.created_at_to) query.created_at_to = params.created_at_to
    if (params?.database_name) query.database_name = params.database_name
    if (params?.details_search) query.details_search = params.details_search
    if (params?.user_id) query.user_id = params.user_id
    if (params?.actor_id) query.actor_id = params.actor_id
    if (params?.action) query.action = params.action
    query.skip = params?.skip ?? 0
    query.limit = params?.limit ?? 100
    if (params?.sort_by) query.sort_by = params.sort_by
    if (params?.sort_direction) query.sort_direction = params.sort_direction
    const res = await apiClient.get<AuditLogItemFull[]>('/logs/audit-log', { params: query })
    return res.data
  },
}


